module.exports = __webpack_public_path__ + "img/smd-2.d5b1c055.png";